webpackJsonp([271588858922066],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _Markdown = __webpack_require__(20);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _propTypes = __webpack_require__(6);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _indexModule = __webpack_require__(302);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var Artikel = function (_React$Component) {
	  _inherits(Artikel, _React$Component);
	
	  function Artikel() {
	    _classCallCheck(this, Artikel);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Artikel.prototype.render = function render() {
	    var article = this.props.data.articleContent;
	    var date = article.date ? new Date(article.date) : false;
	    var dateString = date ? date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear() : false;
	    return _react2.default.createElement(
	      "article",
	      null,
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          article.title
	        ),
	        _react2.default.createElement("meta", { name: "description", content: article.metaDescription }),
	        _react2.default.createElement("meta", { property: "og:title", content: article.title }),
	        _react2.default.createElement("meta", { property: "og:description", content: article.metaDescription })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.header },
	        date && _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.date },
	          dateString
	        ),
	        _react2.default.createElement(
	          "h1",
	          { className: _indexModule2.default.title },
	          article.title
	        )
	      ),
	      article.subtitle && _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.subtitle },
	        article.subtitle
	      ),
	      article.body && _react2.default.createElement(_Markdown2.default, { className: _indexModule2.default.article, source: article.body.body }),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: _indexModule2.default.back, to: "/artikelen/" },
	        "Terug naar alle artikelen"
	      )
	    );
	  };
	
	  return Artikel;
	}(_react2.default.Component);
	
	Artikel.propTypes = propTypes;
	
	exports.default = Artikel;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-components-Artikel----index-module---header---2NMwa","date":"src-components-Artikel----index-module---date---1rvw- src-global-styles----content---title---1yv3A","title":"src-components-Artikel----index-module---title---1LhI2 src-global-styles----content---intro---2xF3Y src-global-styles----content---textSerif---2B2hn src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","subtitle":"src-components-Artikel----index-module---subtitle---1SVf8 src-global-styles----content---title---1yv3A src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","article":"src-components-Artikel----index-module---article---2YVhq src-global-styles----content---textWide---2BLvj src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","back":"src-components-Artikel----index-module---back---3QFcJ"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-components-artikel-index-js-c4eaeb7612189c1e1831.js